import React from 'react';
import { Route } from 'react-router-dom';
import { ContainerWrapper } from '../../components';
import WorkflowsList from './WorkflowsList/WorkflowsList';
import WorkflowCreate from './WorkflowCreate/WorkflowCreate';
import WorkflowEdit from './WorkflowEdit/WorkflowEdit';
import WorkflowDelete from './WorkflowDelete/WorkflowDelete';

const Workflows = ({ match }) => {
    return (
        <div className="Workflows">
            <ContainerWrapper container="workflows">
                <Route exact path={ match.path } component={WorkflowsList} />
                <Route exact path={ `${ match.url }/new` } component={WorkflowCreate} />
                <Route exact path={ `${ match.url }/edit/:workflowId` } component={WorkflowEdit} />
                <Route exact path={ `${ match.url }/delete/:workflowId` } component={WorkflowDelete} />
            </ContainerWrapper>
        </div>
    );
}

export default Workflows;

